import AvailabilityChecker from '../../components/space/availability-checker/AvailabilityChecker.vue';
import SpaceMap from '../../components/space/Map.vue';
import Rating from '../../components/Rating.vue';
import SpaceReviews from '../../components/space/Reviews.vue';
import SpaceEnquiryModal from '../../components/space/EnquiryModal.vue';
import AvailabilityModal from '../../components/space/AvailabilityModal.vue';
import DisableSpaceModal from '../../components/space/DisableSpaceModal.vue';
import EnableSpaceModal from '../../components/space/EnableSpaceModal.vue';
import RemoveListingModal from '../../components/space/RemoveListingModal.vue';
import AdminBar from '../../components/space/AdminBar.vue';
import BookingGuaranteeModal from '../../components/space/BookingGuaranteeModal.vue';
import CongestionModal from '../../components/search/CongestionModal.vue';
import Streetview from '../../components/space/Streetview.vue';
import Location from '../../components/space/Location.vue';
import ImageGallery from '../../components/space/ImageGallery.vue';
import BasePage from '../BasePage';
import AccessHours from '../../components/account/manage-booking/AccessHours.vue';

export default class Space extends BasePage {

    /**
     * @inheritDoc
     */
    getComponents() {
        return {
            Rating,
            ImageGallery,
            AvailabilityChecker,
            SpaceMap,
            SpaceEnquiryModal,
            AvailabilityModal,
            DisableSpaceModal,
            EnableSpaceModal,
            RemoveListingModal,
            AdminBar,
            BookingGuaranteeModal,
            CongestionModal,
            SpaceReviews,
            Streetview,
            Location,
            AccessHours,
        }
    }

}
